import {Pipe, PipeTransform} from '@angular/core';
import * as removeAccents from 'remove-accents';
import { PedidoCadastroItem } from 'src/app/models/pedido-cadastro';

@Pipe({
    name: 'searchFilterPedidoPeriodo'
})
export class SearchFilterPedidoPeriodoPipe implements PipeTransform {

    transform(value: any, word: string): any {
        let resultadoPesquisa = [];
        if (!word) {
            return value;
        } else {
            word = removeAccents(word).toLocaleLowerCase();
            resultadoPesquisa = value.filter(s => {
                return removeAccents(s.descricaoStatusApp).toLocaleLowerCase().includes(word) || removeAccents(s.matricula).toLocaleLowerCase().includes(word)
                    || removeAccents(s.nome).toLocaleLowerCase().includes(word) || removeAccents(s.cpf).toLocaleLowerCase().includes(word) || removeAccents(s.descricaoCartaoPeriodoPadrao).toLocaleLowerCase().includes(word);
            });
        }
        return resultadoPesquisa;
    }

}
